import React, { useState } from 'react';
import { Card, Row, Col, Form } from 'antd';
import { useForm } from 'antd/lib/form/Form';
// import { SearchOutlined } from '@ant-design/icons';

import DF from 'DisplayFramework';
import MGListSelect from '../../Components/MGListSelect';
import Title from 'components/Title';
// import Value from 'components/Value';
import FormInput from 'components/FormInput';
import ParametersListSelect from '../../Components/ParametersListSelect';
import { shouldUpdateCompare } from 'utils/utils2';
import GetLabel from 'DisplayFramework/components/GetLabel';
// import ProductInputByMG from 'pages/Configuration/Management/ParametersFiltering/ProductInputByMG';
import BrokerParlistTransfer from './BrokerParlistTransfer';
// import OfferInput from 'pages/Configuration/Management/ParametersFiltering/OfferInput';

type SelectArgs = {
  parcode: string;
  parlabel: string;
};

export type ParametersFilteringProps = {
  mgid?: number;
  offerid?: number;
  isoffer?: boolean;
  tpidbroker: number;
  isModal?: boolean;
};

const ParametersFilteringBroker = ({
  mgid,
  offerid,
  isoffer,
  tpidbroker,
  isModal,
}: ParametersFilteringProps) => {
  const [form] = useForm();

  const [parcodeAndLabel, setParcodeAndLabel] = useState<SelectArgs>({
    parcode: '',
    parlabel: '',
  });

  const onFinish = ({ parcode, parlabel }: SelectArgs) =>
    setParcodeAndLabel({ parcode, parlabel });

  return (
    <DF.Provider pagcode="parfiltering">
      <Card
        title={<Title level={4} comcode="parametersfilteringTitle"></Title>}
        size="small"
      >
        <Form onFinish={onFinish} form={form} initialValues={{ mgid: mgid }}>
          <Row gutter={16}>
            <Col xs={24} lg={8}>
              <FormInput
                name="mgid"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <MGListSelect style={{ width: '100%' }} disabled={isModal} />
              </FormInput>
            </Col>
            <Form.Item shouldUpdate={() => true} noStyle>
              {({ getFieldValue }) => {
                const filtermode =
                  getFieldValue('offerid') || offerid || isoffer
                    ? 'OFFER'
                    : getFieldValue('prcode')
                    ? 'PRODUCT'
                    : 'ALL';

                return (
                  <FormInput
                    col
                    xs={8}
                    name="parameter"
                    style={{ width: '100%' }}
                  >
                    <ParametersListSelect
                      parcode={parcodeAndLabel.parcode}
                      parlabel={parcodeAndLabel.parlabel}
                      filtermode={filtermode}
                      partype="LIST"
                      showSearch
                    />
                  </FormInput>
                );
              }}
            </Form.Item>
          </Row>

          {/* <Row>
            {!offerid && offerid !== 0 && !isoffer && (
              <>
                <FormInput col xs={2} comcode="search">
                  <Value></Value>
                </FormInput>
                <FormInput col xs={4} name="parcode" />
                <FormInput col xs={8} name="parlabel" />

                <Col xs={2} style={{ textAlign: 'left' }}>
                  <Form.Item shouldUpdate={() => true} noStyle>
                    {({ getFieldValue }) => (
                      <Button
                        onClick={() =>
                          setParcodeAndLabel({
                            parcode: getFieldValue('parcode'),
                            parlabel: getFieldValue('parlabel'),
                          })
                        }
                      >
                        <SearchOutlined />
                      </Button>
                    )}
                  </Form.Item>
                </Col>
              </>
            )}
 
          </Row> */}

          <Row justify="center">
            <Col xs={24}>
              <Form.Item
                shouldUpdate={shouldUpdateCompare([
                  'parameter',
                  'mgid',
                  'prcode',
                  'offerid',
                ])}
              >
                {({ getFieldValue }) => {
                  return (
                    <div>
                      <Row>
                        <Col>
                          <Title level={4} comcode="companyFiltering"></Title>
                        </Col>
                      </Row>
                      <Row>
                        <Col span={24}>
                          <BrokerParlistTransfer
                            parameter={getFieldValue('parameter')}
                            mgid={mgid ? mgid : getFieldValue('mgid')}
                            titleAssociated={
                              (<GetLabel label="associatedValues" />) as any
                            }
                            titleAvailable={
                              (<GetLabel label="availableValues" />) as any
                            }
                            tpidbroker={tpidbroker ?? 0}
                          />
                        </Col>
                      </Row>
                    </div>
                  );
                }}
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
    </DF.Provider>
  );
};

export default ParametersFilteringBroker;
